/*
  rgd-kit-core.js — funções puras dos kits (faixas, estimativa, economia, agrupamento).
  Sem DOM e sem fetch de propósito: é o que permite testar em Node.
  No navegador expõe window.RGDKit; em Node exporta via module.exports.
*/
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.RGDKit = api;
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function parseTiers(raw) {
    var list = raw;
    if (typeof raw === 'string') {
      try {
        list = JSON.parse(raw);
      } catch (e) {
        return [];
      }
    }
    if (!Array.isArray(list)) return [];

    var byQty = {};
    list.forEach(function (entry) {
      if (!entry) return;
      var qty = Number(entry.qty);
      var pct = Number(entry.pct);
      if (!Number.isFinite(qty) || !Number.isFinite(pct)) return;
      if (qty < 1 || pct <= 0 || pct > 100) return;
      qty = Math.floor(qty);
      if (byQty[qty] === undefined || pct > byQty[qty]) byQty[qty] = pct;
    });

    return Object.keys(byQty)
      .map(function (qty) {
        return { qty: Number(qty), pct: byQty[qty] };
      })
      .sort(function (a, b) {
        return a.qty - b.qty;
      });
  }

  function resolveTier(tiers, qty) {
    var found = null;
    (tiers || []).forEach(function (tier) {
      if (qty >= tier.qty) found = tier;
    });
    return found;
  }

  function nextTier(tiers, qty) {
    var list = tiers || [];
    for (var i = 0; i < list.length; i++) {
      if (qty < list[i].qty) {
        return { qty: list[i].qty, pct: list[i].pct, missing: list[i].qty - qty };
      }
    }
    return null;
  }

  function estimateTotals(items, tiers) {
    var list = items || [];
    var count = 0;
    var subtotal = 0;

    list.forEach(function (item) {
      var quantity = Number(item.quantity) || 0;
      var price = Number(item.priceCents) || 0;
      count += quantity;
      subtotal += price * quantity;
    });

    var tier = resolveTier(tiers, count);
    var pct = tier ? tier.pct : 0;
    var discount = 0;

    if (pct > 0) {
      // Arredonda linha a linha porque é assim que a Shopify aloca o desconto.
      list.forEach(function (item) {
        var quantity = Number(item.quantity) || 0;
        var price = Number(item.priceCents) || 0;
        discount += Math.round((price * quantity * pct) / 100);
      });
    }

    return {
      count: count,
      subtotal: subtotal,
      discountPct: pct,
      discount: discount,
      total: subtotal - discount,
      tier: tier,
      next: nextTier(tiers, count)
    };
  }

  function groupLinesByKit(lines) {
    var order = [];
    var byId = {};

    (lines || []).forEach(function (line) {
      var id = line && line.kitId;
      if (!id) return;
      if (!byId[id]) {
        byId[id] = {
          kitId: id,
          label: line.label || '',
          lines: [],
          count: 0,
          discountCents: 0
        };
        order.push(id);
      }
      var group = byId[id];
      group.lines.push(line);
      group.count += Number(line.quantity) || 0;
      group.discountCents += Number(line.discountCents) || 0;
      if (!group.label && line.label) group.label = line.label;
    });

    return order.map(function (id) {
      return byId[id];
    });
  }

  function formatMoney(cents, options) {
    var opts = options || {};
    return new Intl.NumberFormat(opts.locale || 'pt-BR', {
      style: 'currency',
      currency: opts.currency || 'BRL'
    }).format((Number(cents) || 0) / 100);
  }

  return {
    parseTiers: parseTiers,
    resolveTier: resolveTier,
    nextTier: nextTier,
    estimateTotals: estimateTotals,
    groupLinesByKit: groupLinesByKit,
    formatMoney: formatMoney
  };
});
